import { v4 as uuidV4 } from 'uuid';

import { AttachmentDraft } from '../types';

const createDraft = ({ file }: { file: File }): AttachmentDraft => ({
  attachmentId: uuidV4(),
  file,
  uploaded: false,
});

export default createDraft;
